import { Button, Stack } from '@mui/material'

import ToggleField from '../common/ToggleField'
import { useState } from 'react'

const EnterBackupCode = ({ onConfirm }) => {
  const [backupCode, setBackupCode] = useState('')
  return (
    <Stack
      sx={{
        gap: 4,
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
      }}
    >
      <ToggleField
        value={backupCode}
        onChange={(e) => setBackupCode(e.target.value)}
        toggleAriaLabel="toggle code visibility"
        sx={{ width: '100%' }}
      />
      <Button
        id="verify-button"
        variant="contained"
        color="primary"
        onClick={() => onConfirm(backupCode)}
      >
        Confirm
      </Button>
    </Stack>
  )
}

export default EnterBackupCode
